import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis, Tooltip,
  ArgumentAxis, CommonSeriesSettings, } from 'devextreme-react/chart';
import PieChart, {
  Legend as PCLegend,
  Series as PCSeries,
  Tooltip as PCTooltip,
  Label,
} from 'devextreme-react/pie-chart';
import { groupBy } from '../../utils/miscUtil';
import { TagBox } from 'devextreme-react/tag-box';

export default function ESGEmergingTopics(props) {
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [selectedCompaniesList, setSelectedCompaniesList] = useState([]);
  const [carbon1Data, setCarbon1Data] = useState([]);
  const [carbon2Data, setCarbon2Data] = useState([]);
  const [carbon3Data, setCarbon3Data] = useState([]);
  const [carbon4Data, setCarbon4Data] = useState([]);
  const [carbon5Data, setCarbon5Data] = useState([]);
  const [carbon6Data, setCarbon6Data] = useState([]);
  const [carbon7Data, setCarbon7Data] = useState([]);
  const [carbon8Data, setCarbon8Data] = useState([]);
  const [carbon9Data, setCarbon9Data] = useState([]);
  const [carbon10Data, setCarbon10Data] = useState([]);

  useEffect(() => {
    var fd = [];
    var fd1 = [];
    var i = 0;

    fd1 = groupBy(props.data, 'company_name')
    setAllCompaniesList(Object.keys(fd1).sort())

    var originalData = props.data
    if (selectedCompaniesList.length) {
      originalData = originalData.filter((it) => selectedCompaniesList.includes(it['company_name']));
    }

    fd = originalData.filter((e) => {return e["Identifier"]==="187" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"] && e["value"] !== "NR" && e["value"] !== "N"});
    fd = groupBy(fd, "company_name")
    fd1=[]
    let ycnt = Object.keys(fd).length
    let y_companies = Object.keys(fd)
    fd1.push({
      date: (parseInt(props.year)-1).toString(),
      y: ycnt,
      companies: y_companies
    })
    fd = originalData.filter((e) => {return e["Identifier"]==="187" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"] && e["value"] === "N"});
    fd = groupBy(fd, "company_name")
    let ncnt = Object.keys(fd).length
    let n_companies = Object.keys(fd)
    fd1.push({
      date: (parseInt(props.year)-1).toString(),
      n: ncnt,
      companies: n_companies
    })
    fd = groupBy(originalData, "company_name")
    fd1.push({
      date: (parseInt(props.year)-1).toString(),
      nr: Object.keys(fd).length - ycnt - ncnt,
      companies: Object.keys(fd).filter((it) => !y_companies.includes(it) && !n_companies.includes(it))
    })
    setCarbon1Data(fd1);

    fd = originalData.filter((e) => {return e["Identifier"]==="188" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
      if (fd[i]["value"] === "N") {
        fd[i]["value"] = "NR"
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setCarbon2Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="190" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
      if (fd[i]["value"] === "N") {
        fd[i]["value"] = "NR"
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setCarbon3Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="192" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
      if (fd[i]["value"] === "N") {
        fd[i]["value"] = "NR"
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setCarbon4Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="185" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
      if (fd[i]["value"] === "N") {
        fd[i]["value"] = "NR"
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setCarbon5Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="186" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
      if (fd[i]["value"] === "N") {
        fd[i]["value"] = "NR"
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setCarbon6Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="198" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"] && e["value"] !== "NR" && e["value"] !== "N"});
    fd = groupBy(fd, "company_name")
    
    fd1=[]
    ycnt = Object.keys(fd).length
    y_companies = Object.keys(fd)
    fd1.push({
      date: (parseInt(props.year)-1).toString(),
      y: ycnt,
      companies: y_companies
    })
    fd = groupBy(originalData, "company_name")
    fd1.push({
      date: (parseInt(props.year)-1).toString(),
      n: Object.keys(fd).length - ycnt,
      companies: Object.keys(fd).filter((it) => !y_companies.includes(it))
    })
    setCarbon7Data(fd1);

    fd1 = {}
    fd = originalData.filter((e) => {return e["Identifier"]==="198" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"]});
    fd.map((it) => {
      let lst = it.value.split(",")
      for (i=0; i< lst.length; i++) {
        if (parseInt(lst[i].trim())) {
          if (fd1[lst[i].trim()] === undefined) {
            fd1[lst[i].trim()] = {val:0, companies: []}
          }
          fd1[lst[i].trim()].val = fd1[lst[i].trim()].val + 1
          fd1[lst[i].trim()].companies.push(it.company_name)
        }
      }
    })
    fd = Object.keys(fd1).map((key) => ({name: "Category " + key.toString(), val: fd1[key].val, companies: fd1[key].companies}));
    setCarbon8Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="199" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"] && e["value"] !== "NR" && e["value"] !== "N"});
    fd = groupBy(fd, "company_name")
    fd1=[]
    ycnt = Object.keys(fd).length
    y_companies = Object.keys(fd)
    fd1.push({
      date: (parseInt(props.year)-1).toString(),
      y: ycnt,
      companies: y_companies
    })
    fd = groupBy(originalData, "company_name")
    fd1.push({
      date: (parseInt(props.year)-1).toString(),
      n: Object.keys(fd).length - ycnt,
      companies: Object.keys(fd).filter((it) => !y_companies.includes(it))
    })
    setCarbon9Data(fd1);

    fd = originalData.filter((e) => {return e["Identifier"]==="201" && e["year"] ===(parseInt(props.year)-1).toString() && e["value"]});
    fd.map((it) => {
      it.value = parseFloat(it.value)
    })
    setCarbon10Data(fd);

  }, [props.data, props.year, selectedCompaniesList]);

  const onCompaniesChanged = useCallback((e) => {
    setSelectedCompaniesList(e.value);
  }, [setSelectedCompaniesList])

  const customizeTooltip = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.seriesName}: ${pointInfo.originalValue}</div><div class="tooltip-body">${pointInfo.point.data["companies"].join(", ")}</div></div>`
    return {
      html: txt,
    }
  }, []);

  const customizeTooltip2 = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.argumentText}: ${pointInfo.valueText}</div><div class="tooltip-body">${pointInfo.point.data.companies.join(", ")}</div></div>`
    return {
      html: txt,
    }
  }, []);

  const customizeTooltip3 = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.argumentText} : ${pointInfo.originalValue}</div><div class="tooltip-body">${pointInfo.point.data["companies"].join(", ")}</div></div>`
    return {
      html: txt,
    }
  }, []);

  function customizePoint(point) {
    let fillId;
    switch (point.argument) {
      case 'Y':
        fillId = "rgba(20, 77, 109, 1)";
        break;
      case 'N':
        fillId = "rgba(236, 80, 32, 1)";
        break;
      case 'NR':
        fillId = "rgba(0, 0, 0, 0.3)";
        break;
      default:
        break;
    }
    return { color: { fillId } };
  }

  return (
    <>
    <h4>Emerging Topics in {parseInt(props.year)-1} </h4>
    <div className="d-flex flex-row">
      <TagBox
          dataSource={allCompaniesList}
          value={selectedCompaniesList}
          showDropDownButton={true}
          width="100%"
          activeStateEnabled={true}
          multiline={false}
          showSelectionControls={true}
          onValueChanged={onCompaniesChanged}
          label={"Company"}
          labelMode="floating"
          placeholder={"Select Companies"}
      />
    </div>
    <hr className={'mb-4'}/>

    <div className="d-flex flex-column justify-content-between">
      <h5>Carbon Credit Strategies</h5>
      <Chart
        id="chart"
        width="100%"
        dataSource={carbon1Data}
        title={"Companies Disclosing Offsets as a Part of a Carbon Reduction Strategy"}
        rotated={true}
        barGroupWidth={40}
        height={"250px"}
      >
        <ArgumentAxis visible={false}/>
        <CommonSeriesSettings
          argumentField="date"
        />
        <Series
          type="stackedbar"
          valueField={"y"}
          name={"Y"}
          ignoreEmptyPoints={true}
          color="rgba(20, 77, 109, 1)"
        />
        <Series
          type="stackedbar"
          valueField={"n"}
          name={"N"}
          ignoreEmptyPoints={true}
          color="rgba(236, 80, 32, 1)"
        />
        <Series
          type="stackedbar"
          valueField={"nr"}
          name={"NR"}
          ignoreEmptyPoints={true}
          color="rgba(0, 0, 0, 0.3)"
        />
        <ValueAxis showZero={true} />
        <Legend
          visible={true}
          rowCount={1}
          verticalAlignment="bottom"
          horizontalAlignment="center"/>
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltip}
        />
      </Chart>
      <div className="d-flex flex-row w-100 justify-content-between">
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Generating Carbon Offsets"}
            customizePoint={customizePoint}
            dataSource={carbon2Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1} horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip2}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Retiring Carbon Offsets"}
            customizePoint={customizePoint}
            dataSource={carbon3Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1} horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip2}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Purchasing Renewable Energy Credits"}
            customizePoint={customizePoint}
            dataSource={carbon4Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1} horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip2}>
            </PCTooltip>
          </PieChart>
        </div>
      </div>
      <hr className={'mb-4'}/>
      <h5>Emission Monitoring Trends</h5>
      <div className="d-flex flex-row w-100 justify-content-between">
        <div className="d-flex flex-column justify-content-between" style={{width:"49%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Companies using Flyovers"}
            customizePoint={customizePoint}
            dataSource={carbon5Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1} horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip2}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"49%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Companies Using Continous Monitoring"}
            customizePoint={customizePoint}
            dataSource={carbon6Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1} horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip2}>
            </PCTooltip>
          </PieChart>
        </div>
      </div>
      <hr className={'mb-4'}/>
      <h5>Scope 3 Strategies</h5>
      <Chart
        id="chart"
        width="100%"
        dataSource={carbon7Data}
        title={"Companies Disclosing a Scope 3 Philosophy"}
        rotated={true}
        barGroupWidth={40}
        height={"250px"}
      >
        <ArgumentAxis visible={false}/>
        <CommonSeriesSettings
          argumentField="date"
        />
        <Series
          type="stackedbar"
          valueField={"y"}
          name={"Y"}
          ignoreEmptyPoints={true}
          color="rgba(20, 77, 109, 1)"
        />
        <Series
          type="stackedbar"
          valueField={"n"}
          name={"N"}
          ignoreEmptyPoints={true}
          color="rgba(236, 80, 32, 1)"
        />
        <ValueAxis showZero={true} />
        <Legend
          visible={true}
          rowCount={1}
          verticalAlignment="bottom"
          horizontalAlignment="center"/>
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltip}
        />
      </Chart>
      <Chart
        id="chart"
        dataSource={carbon8Data}
        title={"Commonly Disclosed Scope 3 Categories"}
      >
        <CommonSeriesSettings
          argumentField="name"
        />
        <Series
          type="bar"
          valueField="val"
          name="Value"
          color="rgba(20, 77, 109, 1)"
        />
        <ValueAxis showZero={true} />
        <Legend
          visible={false}
          rowCount={1}
          verticalAlignment="bottom"
          horizontalAlignment="center"/>
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltip3}
        />
      </Chart>
      <hr className={'mb-4'}/>
      <h5>Cost of Carbon</h5>
      <Chart
        id="chart"
        width="100%"
        dataSource={carbon9Data}
        title={"Companies Disclosing the Internal Use of Carbon Pricing"}
        rotated={true}
        barGroupWidth={40}
        height={"250px"}
      >
        <ArgumentAxis visible={false}/>
        <CommonSeriesSettings
          argumentField="date"
        />
        <Series
          type="stackedbar"
          valueField={"y"}
          name={"Y"}
          ignoreEmptyPoints={true}
          color="rgba(20, 77, 109, 1)"
        />
        <Series
          type="stackedbar"
          valueField={"n"}
          name={"N"}
          ignoreEmptyPoints={true}
          color="rgba(236, 80, 32, 1)"
        />
        <ValueAxis showZero={true} />
        <Legend
          visible={true}
          rowCount={1}
          verticalAlignment="bottom"
          horizontalAlignment="center"/>
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltip}
        />
      </Chart>
      <Chart
        id="chart"
        dataSource={carbon10Data}
        title={"Internal Cost of Carbon"}
        rotated={true}
      >
        <CommonSeriesSettings
          argumentField="company_name"
        >
          <Label
            wordWrap="normal"
            position="inside"
          />
        </CommonSeriesSettings>
        <ArgumentAxis>
          <Label
            wordWrap="normal"
            position="inside"
          />
        </ArgumentAxis>
        <Series
          type="bar"
          valueField="value"
          color="rgba(92, 194, 215, 1)"
        />
        <ValueAxis showZero={true} />
        <Legend visible={false}/>
      </Chart>
    </div>
    </>
  );
}
